
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;
// 睦邻用户留言
 
//前端分页查询
export const getHelpUserMessage = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/HelpUserMessage`, {params: data})
}
//前端分页查询 根据唯一id
export const getHelpUserMessageById = (id: any): any => {
    return axios.get(`${baseURL}/HelpUserMessage/${id}`)
}
// 提交留言
export const postHelpUserMessage = (data: any): Promise<any> => {
    return axios.post(`${baseURL}/HelpUserMessage`, data)
}